import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {Layout as AppLayout} from 'src/layouts/app';

const IndexPage = lazy(() => import('src/pages/supervisor/index'));
const ApprovalPage = lazy(() => import('src/pages/supervisor/[caseID]/approval'));


export const SupervisorRoutes = [
    {
        path: 'supervisor',
        element: (
            <AppLayout>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </AppLayout>
        ),
        children: [
            {
                index: true,
                element: <IndexPage/>
            },
            {
                path: ':id/approval',
                element: <ApprovalPage/>
            },
        ]
    }
];
